import React from 'react';
import ReactDOM from 'react-dom/client';
import Cont from './Cont'

ReactDOM.createRoot(
  document.getElementById("root")
).render(<Cont />)
